export default class Axle {
  constructor(number, axleIsAPusher) {
    this.number = number;
    this.x      = null;
    this.y      = 42 - this.pusherShift(axleIsAPusher);
    this.radius = 20;
  }

  draw(ctx, color) {
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.font      = '14px Arial';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(this.number, this.x, this.y + 5);
  }

  pusherShift(axleIsAPusher) {
    if (!axleIsAPusher) { return 0; }

    return 20;
  }
};
